module.exports = __webpack_public_path__ + "static/img/EcoStruxure-ADMS.c0dc0a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/EcoStruxure-ADMS.jpg
// module id = GRN/
// module chunks = 0